import { Container, Section, PageHero } from "../components/common";
import { useSeo, breadcrumbLd } from "../lib/seo";

function LegalShell({ title, path, updated, children }) {
 useSeo({ title: `${title} | RPM Auto Repair`, description: `${title} for RPM Auto Repair, Riverside CA.`, path,
 jsonLd: [breadcrumbLd([{ name: "Home", path: "/" }, { name: title, path }])] });
 return (
 <>
 <PageHero title={title} crumbs={[{ name: "Home", path: "/" }, { name: title, path }]} />
 <Section>
 <Container className="prose-rpm max-w-3xl">
 <p className="text-sm text-muted-foreground">Last updated: {updated}</p>
 {children}
 </Container>
 </Section>
 </>
 );
}

export function Privacy() {
 return (
 <LegalShell title="Privacy Policy" path="/privacy-policy" updated="January 2026">
 <p>RPM Auto Repair ("we", "us") respects your privacy. This policy explains what information we collect and how we use it when you visit our website or use our services.</p>
 <h2>Information We Collect</h2>
 <p>We collect information you voluntarily provide, such as your name, phone number, email, vehicle details, and message, when you request an appointment or contact us. We may also collect standard, non-identifying analytics data (such as pages visited) to improve our website.</p>
 <h2>How We Use Your Information</h2>
 <ul><li>To schedule and confirm your appointment</li><li>To respond to your questions and provide estimates</li><li>To improve our services and website experience</li></ul>
 <h2>Information Sharing</h2>
 <p>We do not sell or rent your personal information. We only share information with service providers who help us operate our business (for example, to send appointment confirmations) and as required by law.</p>
 <h2>Data Security</h2>
 <p>We take reasonable measures to protect your information. However, no method of transmission over the internet is completely secure.</p>
 <h2>Your Choices</h2>
 <p>You may request that we update or delete your personal information at any time by contacting us at rpmauto2011@gmail.com or (951) 653-4777.</p>
 <h2>Contact Us</h2>
 <p>Questions about this policy? Call (951) 653-4777 or email rpmauto2011@gmail.com.</p>
 </LegalShell>
 );
}

export function Terms() {
 return (
 <LegalShell title="Terms of Service" path="/terms" updated="January 2026">
 <p>Welcome to RPM Auto Repair. By using our website and services, you agree to the following terms.</p>
 <h2>Services</h2>
 <p>We provide automotive repair and maintenance services. All work is subject to inspection and a written estimate. We do not perform repairs without your authorization.</p>
 <h2>Estimates & Pricing</h2>
 <p>Estimates are provided in good faith based on inspection. Final pricing may vary if additional issues are discovered, in which case we will contact you for approval before proceeding.</p>
 <h2>Warranty</h2>
 <p>Qualifying repairs are covered by our nationwide 24-month/24,000-mile NAPA AutoCare warranty. Warranty terms are provided at the time of service and are subject to the conditions of the NAPA program.</p>
 <h2>Appointments</h2>
 <p>Appointment requests submitted online are requests, not confirmations. We will contact you to confirm availability. Please provide accurate contact and vehicle information.</p>
 <h2>Limitation of Liability</h2>
 <p>To the fullest extent permitted by law, RPM Auto Repair is not liable for indirect or consequential damages. Our total liability is limited to the amount paid for the service in question.</p>
 <h2>Contact</h2>
 <p>For questions about these terms, contact us at (951) 653-4777 or rpmauto2011@gmail.com.</p>
 </LegalShell>
 );
}
